<template>
<div class="home container border-left-light border-right-light">
    <header class="pt-2">
        <div v-if="template.headerLogos">
            <a v-for="(item, index) in template.headerLogos" :key="index" :href="item.href ? item.href : '#/home'" :target="item.href.startsWith('http') ? '_blank' : ''" class="float-right pt-2 mr-2 mb-n4">
                <img :src="item.logo" class="float-right pt-2 mr-2 mb-n4" :alt="item.alt" :height="item.height" />
            </a>
        </div>
    </header>
    <!-- Page Content Desktop -->
    <div class="container-fluid px-0">
        <div class="container pt-1 pb-5 px-0">
            <div class="row">
                <div class="col-md-12 mt-1 mt-md-0 mx-auto text-center">
                    <div v-if="template.centralLogo" class="text-center pt-4">
                        <img v-if="template.centralLogo" :src="template.centralLogo[0].logo" :height="template.centralLogo[0].height" class="mb-4" :alt="template.centralLogo[0].alt" />
                    </div>
                    <div v-if="surveyResult && surveyResult.userAnswers && formatNameChildren().length">
                        <div v-for="(item, index) in formatNameChildren()" :key="item">
                            <h3 style="font-size: 1.325rem; margin-bottom: 25px;" v-if="index == 0">
                                Tire um print da tela para salvar as informações e acessá-las quando precisar!
                            </h3>
                            <p style="font-size: 1.225rem;">
                                {{ index + 1 }} - <strong style="font-weight: 700;">{{ item }}</strong>
                            </p>
                        </div>
                    </div>   
                    
                    <!-- while don't gets the voucher / biometry data -->
                    <section v-if="returnApiMsg" class="mb-5 pb-5 pt-5">
                        <div>
                            <h4 class="text-first-color font-italic mb-4">{{ template.title }}</h4>
                            <p v-if="template.centralLogo && !template.centralLogo[0].alt.includes('Ponte')" class="text-second-color mb-3">
                                <strong>
                                    {{
                      returnApiMsg.message
                        ? returnApiMsg.message
                        : returnApiMsg
                    }}
                                    <!-- gets '.message' if is a network error, else start with 'Carregando...' and get response from api -->
                                </strong>
                            </p>

                            <div v-if="returnApiMsg" class="text-center">
                                <button class="btn btn-primary my-md-4" @click="submit()">
                                    <i class="fa fa-arrow-left mr-2" /> {{ $t('back') }}
                                </button>
                            </div>
                        </div>
                    </section>

                    <!-- if gets the voucher data-->
                    <section v-else-if="!returnApiMsg" class="text-center pt-5">
                        <h4 class="text-first-color font-italic mb-4">{{ template.title }}</h4>

                        <p class="text-second-color mb-3 px-md-5" style="white-space: pre-line"><strong>{{ template.text }}</strong></p>

                        <!-- qrCode -->
                         
                        <div v-if="template.QRCodeShow || template.qrCodeShow" id="qrcode-wd">
                            <qrcode-vue v-if="template.QRCodeShow || template.qrCodeShow" class="p-3" :value="qrCodeWithTimeValidity" render-as="svg" :size="size" level="L" />
                        </div>
                        <!-- biometry data -->
                        <section v-if="template.registerBiometry" class="mb-4 text-center">
                            <!-- errors or messages from API-->
                            <p class="text-second-color mt-4 mb-2" v-if="biometryApiMsg">
                                {{ biometryApiMsg }}
                            </p>

                            <button v-else class="btn btn-home btn-block mt-4 mb-2 btn-validate btn-biometry" @click="goToBiometry()" :style="{ backgroundColor: template.biometryBtnColor, color: template.biometryBtnTxtColor}">
                                {{ template.biometryBtnTxt }}
                            </button>
                        </section>

                        <h4 class="text-second-color"> {{this.voucher.name1 ? this.voucher.name1 + " " + this.voucher.name2 : nome + " " + sobreNome}}</h4>
                        <h4 class="text-second-color mb-4">{{ userId }}</h4>
                        {{ response }}

                        <button v-if="userHasInvite" @click="redirectToNewURL()" class="mt-3 mb-3 mx-auto button-st-white-init d-block">
                            {{  $t('add_new_guest') }}
                        </button>

                        <!-- Dependents Voucher -->
                        <div v-if="dependentsQuest.qt" class="mb-4">
                            <p class="text-second-color mb-1">
                                <strong>
                                    <span v-if="dependentsQuest.qt == 1">{{ $t('minor_name') }}</span>
                                    <span v-else-if="dependentsQuest.qt > 1">{{ $t('minors_names') }}</span>
                                    <br>
                                </strong>
                            </p>
                            <div class="d-flex justify-content-center mt-2">
                                <section>
                                    <p v-for="(name, index) in dependentsQuest.name" :key="index" class="text-second-color mb-1">{{ name }}</p>
                                </section>
                                <div>
                                    <section v-for="(idade, index) in dependentsQuest.idade" :key="index">
                                        <p v-if="idade == '1'" class="text-second-color ml-4 mb-1">{{ idade }} {{ $t('year') }}</p>
                                        <p v-else class="text-second-color ml-4 mb-1">{{ idade }} {{ $t('years') }}</p>
                                    </section>
                                </div>
                            </div>
                        </div>

                        <!-- Event date and local Voucher -->
                        <div class="text-first-color mb-4 px-3 px-md-5">
                            <p v-if="template.stage" class="mb-0 font-weight-bold"><span class="text-second-color">{{ $t('stage') }} </span>{{ template.stage }}</p>
                            <p v-if="template.local" class="mb-0 font-weight-bold"><span class="text-second-color">{{ $t('location') }} </span>{{ template.local }}</p>
                            <p v-if="voucher.dateStart" class="mb-0 font-weight-bold"><span class="text-second-color">{{ $t('date') }} </span>{{ voucher.dateStart }}</p>
                            <p v-if="voucher.timeStart" class="mb-3 font-weight-bold"><span class="text-second-color">{{ $t('hour') }} </span>{{ voucher.timeStart.replace(":00", "") }}</p>
                            <p v-if="voucher.obsMsg" class="mb-1 text-first-color">{{ voucher.obsMsg }}</p>
                        </div>
                    </section>

                    <!-- Logos patrocinadores -->
                    <section class="text-center pt-4">
                        <div v-if="template.partnersLogo && !template.title.includes('Premiação Paulistão Feminino 2022')" class="d-flex flex-wrap justify-content-center align-items-center survey10-logos">
                            <span v-for="(partner, index) in template.partnersLogo" :key="index">
                                <img :src="partner.logo" :height="partner.height" class="mx-2 mb-5" :alt="partner.alt" />
                            </span>
                        </div>
                    </section>
                    <section v-if="survey && template.instructions" class="bg-tag">
                        <p class="text-second-color mb-4 py-3">
                            <strong>
                                {{ template.instructions }}
                            </strong>
                        </p>
                    </section>
                    <section>
                        <span v-if="survey && template.disclaimer " class="mb-5">
                            <p v-for="(disclaimer, index) in template.disclaimer" :key="index" class="text-second-color">
                                {{ disclaimer }}
                            </p>
                        </span>
                    </section>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import FooterGlobal from "./FooterGlobal";
import HeaderGlobal from "./HeaderGlobal";
import QrcodeVue from "qrcode.vue";
import axios from "axios";
const baseDomain = process.env.VUE_APP_BASEDOMAIN;
const baseEnv = process.env.VUE_APP_BASEENV;
const baseUrl = `${baseDomain}/${baseEnv}`;

import {
    Survey
} from "@/services/Survey.js";
const surveyServices = new Survey();

export default {
    name: "SurveyFinal10",
    components: {
        FooterGlobal,
        HeaderGlobal,
        QrcodeVue,
    },
    data: () => ({
        qtSomos: 0,
        surveyResult: null,
        size: 150,
        voucher: [],
        voucherDuply: [],
        returnApiMsg: "Carregando...",
        qrCodeWithTimeValidity: "",
        loadingBiometry: false,
        biometryData: "",
        biometryApiMsg: ""
    }),
    watch: {
        surveyResult(newVal) {
            if (newVal && newVal.length) {
                this.formatNameChildren();
            }
        }
    },
    computed: {
        userId() {
            return this.$store.state.userId;
        },
        projectTag() {
            return "#" + this.$store.state.project.projectTag;
        },
        hashtags() {
            return (
                this.$store.state.project.projectTag +
                "," +
                this.$store.state.project.aditionalTags
            );
        },
        company() {
            return this.$store.state.project.entityName;
        },
        sharingMessage() {
            return this.$store.state.project.sharingMessage;
        },
        projectURL() {
            return "https://" + this.$store.state.project.projectURL + "/";
        },
        projectTitle() {
            return this.$store.state.project.projectTitle;
        },
        userHasInvite() {
            return this.$store.state.invite && this.$store.state.invite.qtInv > 1
        },
        nick() {
            return this.$store.state.project.nickName;
        },

        nome() {
            var n = this.fillString("<@RQ:101@>");
            return n;
        },
        sobreNome() {
            var n = this.fillString("<@RQ:102@>");
            return n;
        },
        template() {
            return this.$store.state.template.finalSurvey10;
        },
        imgPath() {
            let array = this.$store.state.template.header.logos;
            let obj = array.pop();
            let path = obj.logo;
            return path;
        },
        surveyUserId() {
            return this.$store.state.surveyUserId;
        },

        dependentsQuest() {
            if (this.template.dependentsQuestion) {
                const questId = this.template.dependentsQuestion
                const res = this.$store.state.answers[questId];
                if (res) {
                    let obj = {}
                    const resArray = res.split(';')
                    obj.name = []
                    obj.idade = []
                    obj.qt = resArray.shift()
                    resArray.forEach(el => {
                        obj.name.push(el.split(':')[1])
                        obj.idade.push(el.split(':')[0])
                    })
                    obj.name = obj.name.slice(0, -1)
                    obj.idade = obj.idade.slice(0, -1)
                    return obj
                } else return false
            } else return false
        },

    },
    methods: {
        getSurveyResult() {
            let baseurl = baseUrl.replace("https:/",'')
            const url = `https://${baseurl}/SurveyResult/${this.surveyUserId}`;
            axios.get(url)
            .then((res) => {
                if (res.data.data.userAnswers) {
                    this.surveyResult = res.data.data;
                    if(this.surveyResult){
                        setTimeout(() => {
                            this.formatNameChildren();
                        }, 700);
                    }
                } else {
                    console.log('Erro ao recuperar o resultado da votação:\n  ' + res.data.header.msg);
                }
            })
            .catch((err) => {
                console.log('Erro ao recuperar o resultado da votação:\n  ' + err);
            });
        },
        formatNameChildren() {

            if (this.surveyResult && this.surveyResult.userAnswers) {

                const question = this.surveyResult.userAnswers.find(q => q.quetionId === 10003);

                if (question && question.answers) {
                   
                    const childrenNames = question.answers
                        .map(answer => answer.answer.split(':')[1]?.trim())
                        .filter(name => name);
                    
                    return childrenNames;
                }
            }

            return [];  
        },
        updateValidityTime() {
            const currentTime = new Date()
            let validity = new Date(currentTime.getTime() + 10 * 1000)
            const isoString = validity.toISOString()
            this.qrCodeWithTimeValidity = this.voucher.qrData + ',' + btoa(isoString)
        },
        redirectToNewURL() {
            const savedItem = localStorage.getItem('homeUrlType10');
            window.location.href = savedItem;
        },
        submit() {
            this.$router.push("survey");
        },
        fillString(s) {
            if (!s) return s;
            if (s.includes("<@") && s.includes("@>")) {
                var s1 = s.split("<@");
                var s2 = s1[1].split("@>");
                var s3 = s2[0].split(":");
                var rid = s3[1];
                var value = this.$store.state.answers[rid];
                s = s1[0] + value + s2[1];
            }
            return s;
        },
        loadVoucher() {
            return surveyServices
                .SurveyVoucher(this.surveyUserId)
                .then((res) => {
                    this.voucher = []; // ou null, para resetar antes
                    this.voucherDuply = []; // ou null, para resetar antes
                    this.$set(this, 'voucher', res);
                    this.$set(this, 'voucherDuply', res);
                    if (!this.template.registerBiometry) {
                        this.returnApiMsg = ""
                    }
                    this.updateValidityTime()
                    this.interval = setInterval(() => {
                        this.updateValidityTime()
                    }, 10000)
                })
                .catch((err) => {
                    this.returnApiMsg = err;
                });
        },
        loadBiometry() {
            this.loadingBiometry = true
            surveyServices
                .getBiometry(this.surveyUserId)
                .then((res) => {
                    this.biometryData = res;
                    this.loadingBiometry = false
                    this.goToBiometry()
                })
                .catch((err) => {
                    this.biometryApiMsg = err;
                    this.returnApiMsg = ""
                    this.loadingBiometry = false
                });
        },
        goToBiometry() {
            window.location = this.biometryData
        }
    },
    created() {
        this.$gtag.event("FinalSurvey", {
            method: "Google"
        });
    },
    beforeMount() {
        if (!this.$store.state.template.style) {
            this.$nextTick(() => {
                this.$router.push('home')
            })
        }
        if (this.template.registerBiometry) {
            this.returnApiMsg = "Carregando biometria..."
        }
    },
    mounted() {
        this.getSurveyResult()
        this.loadVoucher().then(() => {
            if (this.template.registerBiometry) {
                this.loadBiometry()
            }
            // alert(JSON.stringify(this.voucher))
        })
        this.$nextTick(() => {
            console.log("Voucher after nextTick: ", this.voucher);
        });
    },
};
</script>

<style scoped>
.container {
    min-height: calc(100vh - 91px - 148.11px);
    max-width: 768px;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3; /* Cor de fundo */
    border-top: 5px solid #000000; /* Cor preta para o spinner */
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 20px auto;
}

/* Animação para o spinner */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.button-st-white-init {
    width: 320px;
    height: 60px;
    border-radius: 10px;
    background: #fff;
    color: black;
    border: none;
    outline: none;
    font-weight: 600;
    font-size: 1.1rem;
}

.c-sharing {
    font-size: 1.5rem;
    font-weight: 300;
}

.bg-tag {
    background-color: rgba(0, 0, 0, 0.5);
}

.survey10-logos>img {
    max-width: 90vw;
}

.btn-biometry {
    width: 100%;
    max-width: 260px;
    margin: 0 auto;
}

.tam-font-fpf {
    font-size: 2.3rem !important;
}

.tam-font-fpf-info {
    font-size: 1.55rem !important;
}

.font-fpf-info-mt {
    margin-top: 10px;
}

.margin-top-fpf-img {
    margin-top: 10px;
}

#qrcode-wd {
    width: 180px;
    height: 180px;
    border-radius: 5px;
    background-color: white;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
}

@media screen and (max-width: 700px) {
    .tam-font-fpf {
        font-size: 1.55rem !important;
        line-height: 1.6 !important;
    }

    .tam-font-fpf-info {
        font-size: 1.08rem !important;
        line-height: 1.6 !important;
    }

    .margin-top-fpf-img {
        margin-top: 10px;
    }
}
</style>
